<template>
    <div class="mpanel">
        <div>
            <!--顶部统计-->
            <div class="card-container">
                <div class="card-item">
                    <div>
                        <div class="card-item-title">词汇总数量</div>
                        <div class="card-item-num">1000</div>
                    </div>
                    <span class="icon">📘</span>
                </div>
                <div class="card-item">
                    <div>
                        <div class="card-item-title">生词数量</div>
                        <div class="card-item-num">1000</div>
                    </div>
                    <span class="icon" style="background: rgba(34, 197, 94, 0.12);">🎯</span>
                </div>
                <div class="card-item">
                    <div>
                        <div class="card-item-title">已掌握数量</div>
                        <div class="card-item-num">1000</div>
                    </div>
                    <span class="icon" style="background: rgba(22, 163, 74, 0.12);">✅</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'NewWordOverview',
    props: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mpanel {
    padding-left: 20px;
    padding-right: 20px;
}

.card-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 15px;
}

.card-item {

    padding-left: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    /* border-radius: 10px; */
    /* box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08); */
    /* border: 1px solid var(--ek-split-lineColor); */
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
    border-right: 1px solid var(--ek-split-lineColor);

}

.card-item .icon {
    width: 38px;
    height: 38px;
    border-radius: 14px;
    display: grid;
    place-items: center;
    background: rgba(37, 99, 235, 0.12);
    color: var(--primary);
    font-size: 1.1rem;
}

.card-item-title {
    font-size: 14px;
    color: var(--ek-text-color2);
}

.card-item-num {
    font-size: 24px;
    font-weight: bold;
    color: var(--ek-text-color1);
    margin-top: 20px;
}
</style>
